// @flow
import * as React from 'react';
import { Item, ItemCaption, ItemCaptionContent, ItemIcon } from '../styles';
import type { AnyIcon } from '~/core/constants/icons';
import { noop } from 'lodash/fp';

type Props = {
    index?: number,
    caption: string,
    icon: AnyIcon,
    action: noop,
    selected?: boolean
};

const PopupItem = ({ index, caption, icon, action, selected }: Props) => (
    <Item key={index} onClick={action}>
        <ItemIcon type={icon} />
        <ItemCaption>
            <ItemCaptionContent selected={selected}>{caption}</ItemCaptionContent>
        </ItemCaption>
    </Item>
);

export default PopupItem;



// WEBPACK FOOTER //
// ./src/components/widgets/context-menu/popup-item/index.js